import type { AssetFinding } from "../api";

/**
 * One finding on the asset detail view (UX §6 "Asset"). The card shows what
 * the draft claimed against what the source actually said, so a reviewer
 * never has to reopen the source themselves to see the gap.
 */
export function FindingCard({ finding }: { finding: AssetFinding }) {
  return (
    <article
      data-finding={finding.finding_id}
      className="flex flex-col gap-2 rounded-ks-md border border-ks-grey-4 bg-ks-surface p-3"
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm font-medium text-ks-ink">{finding.claim}</p>
        {finding.status === "open" && finding.newer_draft_since_review && (
          <span
            data-recheck
            className="rounded-ks-sm border border-ks-purple-3 bg-ks-purple-4 px-2 py-0.5 text-[11px] font-semibold text-ks-purple"
          >
            Newer draft since review. Mark resolved if it&apos;s fixed.
          </span>
        )}
      </div>
      <p className="text-xs text-ks-grey-1">
        <span className="font-semibold text-ks-ink">Source says: </span>
        {finding.source_says}
        <span className="ml-1 text-ks-grey-1">({finding.source_kind})</span>
      </p>
      <div className="flex flex-wrap items-center gap-2 text-[11px] text-ks-grey-1">
        <span className="rounded-ks-sm bg-ks-grey-4/60 px-2 py-0.5">{finding.problem_type}</span>
        <span className="rounded-ks-sm bg-ks-grey-4/60 px-2 py-0.5">origin: {finding.origin_stage}</span>
        {finding.blocking && (
          <span className="rounded-ks-sm bg-ks-fail/10 px-2 py-0.5 font-semibold text-ks-fail">Blocking</span>
        )}
        <span className="rounded-ks-sm bg-ks-grey-4/60 px-2 py-0.5">
          {finding.status === "open" ? "Open" : `Resolved in ${finding.resolved_in_revision ?? "a later revision"}`}
        </span>
      </div>
      {finding.problem_note && <p className="text-[11px] text-ks-grey-1">{finding.problem_note}</p>}
    </article>
  );
}
